// import axios from 'axios'
import { getSession } from "next-auth/react";

async function queryAPI(query, token, context = null) {
  const tokenFromSession = context ? await getSession(context) : token;

  const res = await fetch(process.env.GRAPHQL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${
        tokenFromSession?.user?.image?.access_token ?? token
      }`,
    },
    body: JSON.stringify({
      query,
    }),
  });

  const json = await res.json();
  if (json.errors) {
    throw json.errors;
  }
  return json.data;
}

const api = (() => {
  const GetTypeformReponse = async (typeformID, responseID) => {
    const data = await queryAPI(`
    {
      GetTypeformReponse(
        typeform_id: "${typeformID}"
        response_id: "${responseID}" 
      )
    } 
    `);

    return data?.GetTypeformReponse;
  };

  const getEventBySlug = async (slug) => {
    const data = await queryAPI(
      `
      query {
        eventBySlug( slug: "${slug}" ) {
          id
          title
          category {
            value
            name
          }
        }
      }
    `
    );

    return data.eventBySlug;
  };

  const EventBySlug = async (slug, context = null) => {
    const data = await queryAPI(
      `
    query {
      eventBySlug( slug: "${slug}" ) {
        id
        title
        slug
        start
        description
        img
        status
        id_typeform
        id_addevent
        translated_playback_id
        duration
        min_play
        playback_id 
        is_summit
        summit_date
        day
        agenda_url
        summit_logo
        mini_video
        footer_text
        id_sidetab_typeform
        final_duration
        
        category {
          id
          value
          name
        }

        event_details {
          id
          time
          countries
        }
  
        speakers {
          title
          name
          position
          photo
        }
        redirection_button
      }
    }
    `,
      context
    );

    return data.eventBySlug;
  };

  const Countries = async () => {
    const data = await queryAPI(`
    {
           GetCountries {
             status
             countries{
               name
               value
             }
           }
        }
    `);

    return data.GetCountries;
  };

  const Specialties = async () => {
    const data = await queryAPI(`
      {
        GetSpecialties{
          status
          specialties{
            name
            value
          }
        }
      }
    `);

    return data.GetSpecialties;
  };

  const getUserProperties = async (userId) => {
    const data = await queryAPI(`
    query {
      user(id: ${userId}) {
        id
        id_beyond: beyond_id
        email
        name
        lastname
        scndlastname
        id18
        country
        
      }
    }
    `);

    return data.user;
  };

  const Login = async (email) => {
    const data = await queryAPI(
      `mutation {
        Login (
          username: "${email}"
  
        ) {
          status
          message
          access_token
          refresh_token
          expires_in
          token_type
          user {
            id
            name
            lastname
            scndlastname
            beyond_id
            id18
            country
            email
            is_from_latam
          }
        }
      }`
    );

    return data.Login;
  };

  const LoginLatam = async (email) => {
    const data = await queryAPI(
      `mutation {
        LoginLatam (
          username: "${email}"
  
        ) {
          status
          access_token
          refresh_token
          expires_in
          token_type
          user {
            id
            name
            lastname
            scndlastname
            beyond_id
            id18
            country
          }
        }
      }`
    );

    return data.LoginLatam;
  };

  const EventById = async (id, token = null, context = null) => {
    const data = await queryAPI(
      `
    {
      event(id: ${id}) {
        id
        title
        start
        end
        slug
        playback_id
        slido_id
        pdf_url
        description
        id_typeform
        id_event_beyond
        pdf_url
        status
        id_addevent
        exam_id 
        min_approved
        min_tries
        is_summit
        day
        category {
          id
          value
          name
        }
        link {
          id
          title
          url
          info
        }
        speakers {
          title
          name
          position
          photo
        }
        pre_survey_id
        show_pre_survey
        post_survey_id
        show_post_survey
        redirection_button
        show_buttons
      }
    }
    `,
      token,
      context
    );

    return data.event;
  };

  const getUserInfo = async (token) => {
    const data = await queryAPI(
      `
      query {
        user: getUserInfo {
          id
          name
          lastname
          scndlastname
          veeva_2
          dataMismatch
        }
      }
    `,
      token
    );

    return data.user;
  };

  const GetMessages = async (event_id, token) => {
    const data = await queryAPI(
      `
    {
      MessagesByEvent(event_id: ${event_id}){
        id
        message
        user {
          id
          name
          beyond_id
        }
      }
    }
    `,
      token
    );

    return data.MessagesByEvent;
  };

  const SaveScore = async (eventID, finalScore, responseID, token) => {
    const data = await queryAPI(
      `
    mutation {
      SaveScore(
        event_id: ${eventID}
        final_score: ${finalScore}
        response_id: "${responseID}"
      )
    }
    `,
      token
    );

    return data;
  };

  const GetUserEmail = async (user_beyond_id, token) => {
    const data = await queryAPI(
      `
    {
      getUserEmail(
        beyond_id: "${user_beyond_id}"
      ) {
        id
        email
      }
    }
    `,
      token
    );

    return data.getUserEmail;
  };

  const getTalkById = async (id) => {
    const data = await queryAPI(`
    query {
      GetTalkById(
        id: ${id}
      ) {
        id
        title
        playback_id
        translated_playback_id
      }
    }
    `);

    return data?.GetTalkById;
  };

  const getFirstEventTalk = async (eventID) => {
    const data = await queryAPI(`
    query {
      GetFirstEventTalk(
        event_id: ${eventID}
      ) {
        id
        title
        playback_id
        translated_playback_id
        thumbnail
        speaker {
          name
        }
      }
    }
    `);

    return data?.GetFirstEventTalk;
  };

  const getDiplomaProgress = async (eventID, duration, token) => {
    const data = await queryAPI(
      `
    query{
      GetDiplomaProgress(
        event_id: ${eventID}
        duration: ${duration}
      )
    }
    `,
      token
    );

    return data?.GetDiplomaProgress;
  };

  const getEventTalks = async (eventID, currentTalkID) => {
    const data = await queryAPI(`
    query {
      GetEventTalks(
        event_id: ${eventID}
        curren_talk_id: ${currentTalkID}
      ) {
        id
        title
        thumbnail
        speaker {
          name
        }
      }
    }
    `);

    return data?.GetEventTalks;
  };

  const userExists = async (email) => {
    const data = await queryAPI(`
    query {
      UserExists(user_email: "${email}")
    }
    `);

    return data?.UserExists;
  };

  const RegisterLatam = async (
    email,
    name,
    lastname,
    scndlastname,
    zip_code,
    professional_ID,
    specialism,
    country,
    cellphone,
    id18,
    isFromLatam
  ) => {
    const data = await queryAPI(`
    mutation {
      RegisterLatam(
        email: "${email}"
        name: "${name}"
        lastname: "${lastname}"
        scndlastname: "${scndlastname}"
        zip_code: "${zip_code}"
        professional_ID: "${professional_ID}"
        specialism: "${specialism}"
        country: "${country}"
        cellphone: "${cellphone}"
        ID_18: "${id18}"
        is_from_latam: ${isFromLatam}
      ) {
        user_exists
        status
    		message
        user {
          id
          name
          lastname
          scndlastname
          beyond_id
          id18
          country
          email
        }
      }
    }
    `);

    return data?.RegisterLatam;
  };

  // email,
  // beyond_id,
  // country,
  // dataMismatch,
  // lastname,
  // name,
  // password,
  // professional_ID,
  // zip_code,
  // registerDate,
  // remember_url,
  // role,
  // scndlastname,
  // specialism,
  // tries,
  // userVersion,
  // validated,
  // legacyRegisterDate,
  // sepName,
  // sepSpecialty,
  // sepInstitution,
  // cellphone,
  // id18,

  const registerFromBeyond = async (c) => {
    const data = await queryAPI(`
    mutation {
      registerFromBeyond(
        email: "${c.email || null}"
        beyond_id: "${c.beyond_id || ""}"
        country: "${c.country || null}"
        dataMismatch: ${c.dataMismatch || true}
        lastname: "${c.lastname || null}"
        name: "${c.name || ""}"
        password: "${c.password || ""}"
        professional_ID: "${c.professional_ID || null}"
        zip_code: "${c.zip_code || ""}"
        registerDate: ${c.registerDate || 0}
        remember_url: "${c.remember_url || "/"}"
        role: "${c.role || "USER"}"
        scndlastname: "${c.scndlastname || ""}"
        specialism: "${c.specialism || null}"
        tries: ${c.tries || 0}
        userVersion: "${c.userVersion || "USER_V2"}"
        validated: ${c.validated || false}
        legacyRegisterDate: ${c.legacyRegisterDate || 0}
        sepName: "${c.sepName || ""}"
        sepSpecialty: "${c.sepSpecialty || ""}"
        sepInstitution: "${c.sepInstitution || ""}"
        cellphone: "${c.cellphone || ""}"
        id18: "${c.id18 || ""}" 
      )
    }
`);

    return data?.registerFromBeyond;
  };

  const createVODSummitTracking = async (eventID, talkID) => {
    const data = await queryAPI(`
    mutation {
      CreateVODSummitTracking(
        event_id: ${eventID}
        talk_id: ${talkID}
      )
    } 
    `);

    return data?.CreateVODSummitTracking;
  };

  const updateVODSummitAccumulatedTime = async (
    eventID,
    talkID,
    milliseconds,
    token
  ) => {
    const data = await queryAPI(
      `
    mutation {
      UpdateVODSummitAccumulatedTime(
        event_id: ${eventID}
        talk_id: ${talkID}
        milliseconds: ${milliseconds}
      )
    }
    `,
      token
    );

    return data?.UpdateVODSummitAccumulatedTime;
  };

  const SendMessage = async (event_id, message, token) => {
    const data = await queryAPI(
      `
    mutation{
      SendToFilterer(
        event_id: "${event_id}",
        message: "${message}"
      ),
      {
        message
      }
    }
    `,
      token
    );

    return data.SendToFilterer;
  };

  const CreateTracking = async (event_slug, source, medium, token) => {
    const data = await queryAPI(
      `
      mutation {
        CreateTracking(
          event_slug: "${event_slug}"
          source: "${source}"
          medium: "${medium}"
        ) {
          status
          is_new_record
          message
        }
      }
    `,
      token
    );

    return data.CreateTracking;
  };

  // const Logout = function() {
  //   this.query = `mutation {
  //     logout {
  //       status
  //       message
  //     }

  //   }`
  // }
  // Logout.prototype = queryProto

  const Logout = async (token) => {
    const data = await queryAPI(
      `
    mutation {
      logout {
        status
        message
      }

    }
    `,
      token
    );

    return data.logout;
  };

  const Register = async (dataForm, eventId) => {
    const data = await queryAPI(`
    mutation {
      Register(
        email: "${dataForm.emailR}"
        name: "${dataForm.nombre}"
        lastname: "${dataForm.aPaterno}"
        scndlastname: "${dataForm.aMaterno}"
        zip_code: "${dataForm.codigoPostal}"
        professional_ID: "${dataForm.cedula}"
        specialism: "${dataForm.especialidad}"
        country: "${dataForm.pais}"
        event_id: ${eventId}
        agree: ${dataForm.agree}
        cellphone: "${dataForm.telefono}"
      ){
        status
        access_token
        refresh_token
        expires_in
        user {
          id
          beyond_id
          id_beyond: beyond_id
          email
          name
          lastname
          scndlastname
          id18
          country
        }
      }
    }
    `);

    return data.Register;
  };

  const UpdateTracking = async (
    event_id,
    milliseconds,
    endReached,
    is_summit,
    day,
    token
  ) => {
    const data = await queryAPI(
      `
    mutation {
      UpdateTracking(
        event_id: ${event_id}
        milliseconds: ${milliseconds}
        endReached: ${endReached}
        is_summit: ${is_summit}
        day: ${day}
      ) 
    }
    `,
      token
    );

    return data.UpdateTracking;
  };

  const GetUserTracking = async (event_id, token) => {
    const data = await queryAPI(
      `
    {
      GetUserTracking(
        event_id: ${event_id}
      ) {
        id
        running_time
      }
    }
    `,
      token
    );

    return data.GetUserTracking;
  };

  const CheckConstancy = async (event_slug, token) => {
    const data = await queryAPI(
      `
    {
      HasConstancy(event_slug:"${event_slug}"){
        constancy_downloaded
      }
    }
    `,
      token
    );

    return data.HasConstancy;
  };

  const GetScore = async (eventID, token) => {
    const data = await queryAPI(
      `
    query {
      GetScore( event_id: ${eventID}) {
        id
        score
        try
      }
    } 
    `,
      token
    );

    return data.GetScore;
  };

  const EventExists = async (event_slug, token = null) => {
    const data = await queryAPI(
      `
    {
      EventExists(
        event_slug: "${event_slug}"
      )
    }
    `,
      token
    );

    return data.EventExists;
  };

  const ReadUserById = async (beyond_id, token = null) => {
    const data = await queryAPI(
      `
    {
      ReadUserById(
         beyond_id: "${beyond_id}"
      ) {
        id
        email
      }
    }
    `,
      token
    );

    return data.ReadUserById;
  };

  const ReadUserByLiveId = async (liveId, token = null) => {
    const data = await queryAPI(
      `
      query {
        ReadUserByLiveId(live_id: "${liveId}") {
          id
          email
        }
      }
    `,
      token
    );

    return data.ReadUserByLiveId;
  };

  const GetTracking = async (event_slug, token = null) => {
    const data = await queryAPI(
      `
    {
      GetTracking(
        event_slug: "${event_slug}"
      ) {
        id
        end_reached
      }
    }
    `,
      token
    );

    return data.GetTracking;
  };

  const CreateConstancy = async (event_slug, token = null) => {
    const data = await queryAPI(
      `
    mutation {
      CreateConstancy(
        event_slug: "${event_slug}"
      ) {
        was_previously_downloaded
        status
        tracking {
          id
        }
      }
    }
    `,
      token
    );

    return data.CreateConstancy;
  };

  const GetSFToken = async () => {
    const data = await queryAPI(`
    query{
      GetSFToken
    }
    `);

    return data;
  };

  const SendToSFLogin = async (token, email, id18, url, country) => {
    const data = await queryAPI(`
    mutation {
      SendToSFLogin (
        token: "${token}"
        email: "${email}"
        id18: ${!!id18 ? `"${id18}"` : null}
        url: "${url}"
        country: "${country}"
      ) {
        status
        message
      }
    }
    `);

    return data;
  };

  const SendToSFRegister = async (
    token,
    email,
    id18,
    eventName,
    url,
    firstName,
    lastName,
    zp,
    mobile,
    country
  ) => {
    const data = await queryAPI(`
    mutation {
      SendToSFRegister (
        token: "${token}"
        email: "${email}"
        id18: ${!!id18 ? `"${id18}"` : null}
        
        eventName: "${eventName}"
        
        url: "${url}"

        firstName: "${firstName}"
        lastName: "${lastName}"
        zp: "${zp}" 
      
        mobile: ${!!mobile ? `"${mobile}"` : null}

        country: "${country}"
      ) {
        status
        message
      }
    }
    `);

    return data;
  };

  const createTrackingLatam = async (userID, slug) => {
    const data = await queryAPI(`
    mutation {
      CreateTrackingLatam (
        user_id: "${userID}",
        event_slug: "${slug}"
        source: ""
        medium: ""
      )
    }
    `);

    return data.CreateTrackingLatam;
  };

  const getUserIDByEmail = async (email) => {
    const data = await queryAPI(`
    query {
      GetUserIDByEmail(email: "${email}") {
        id
      }
    }
    `);

    return data.GetUserIDByEmail;
  };

  const updateDataMismatch = async (
    email,
    name,
    lastname,
    scndlastname,
    professional_ID,
    specialism = null,
    type,
    token
  ) => {
    const data = await queryAPI(
      `
      mutation {
        updateDataMismatch(
          email: "${email}",
          name: "${name}",
          lastname: "${lastname}",
          scndlastname: "${scndlastname}",
          professional_ID: "${professional_ID}",
          specialism: ${!!specialism ? `"${specialism}"` : null},
          type: ${type}
        ) {
          status
          message
        }
      }
    `,
      token
    );

    return data.updateDataMismatch;
  };

  const getUserInfoById = async (userId) => {
    const data = await queryAPI(`
    query {
      user: getUserInfoById(user_id: ${userId}) {
        name
        lastname
        scndlastname
        email
        professional_ID
        veeva_2
        dataMismatch
      }
    }
    `);

    return data?.user;
  };

  const getEventInfoById = async (eventId) => {
    const data = await queryAPI(`
    query {
      event: getEventInfoById (event_id: "${eventId}") {
        id
        slug
        pdf_url
      }
    }
    `);

    return data?.event;
  };

  const getEventPageData = async (slug) => {
    const data = await queryAPI(`
    query {
      countriesData: GetCountries {
        status
        countries {
          name
          value
        }
      }
      specialtiesData: GetSpecialties {
        status
        specialties{
          name
          value
        }
      }
      eventData: eventBySlug(slug: "${slug}") {
        id
        title
        slug
        start
        description
        img
        status
        id_typeform
        id_addevent
        translated_playback_id
        duration
        min_play
        playback_id 
        is_summit
        summit_date
        day
        agenda_url
        summit_logo
        mini_video
        footer_text
        id_sidetab_typeform
        category {
          id
          value
          name
        }
        event_details {
          id
          time
          countries
        }
        speakers {
          title
          name
          position
          photo
        }
        redirection_button
      }
    }
    `);

    return data;
  };

  const getUserByEmail = async (email) => {
    const data = await queryAPI(`
    query {
      user: getUserByEmail(email: "${email}") {
        id
        id_beyond: beyond_id
        email
        country
        id18
        name
        lastname
        scndlastname
        professional_ID
        specialism
        is_mixpanel_registered
        is_from_latam
      }
    }
    `);

    return data?.user;
  };

  const hasAttended = async (eventId, token) => {
    const data = await queryAPI(
      `
    query {
      hasAttended(event_id: ${eventId})
    }
    `,
      token
    );

    return data?.hasAttended;
  };

  const markAsAttended = async (eventId, token) => {
    const data = await queryAPI(
      `
    mutation {
      markAsAttended(event_id: ${eventId})
    }
    `,
      token
    );

    return data?.markAsAttended;
  };

  const updateUserMixpanelRegistered = async (isRegistered, token) => {
    const data = await queryAPI(
      `
      mutation {
        updateUserMixpanelRegistered(is_registered: ${isRegistered})
      } 
    `,
      token
    );

    return data?.updateUserMixpanelRegistered;
  };

  const getAllTrackings = async ({ eventId, token }) => {
    const data = await queryAPI(
      `
      query {
        trackings: getEventTrackings(event_id: ${eventId}) {
          id
          percentage
          accumulated_time
          accumulated_time_minutes
          user {
            id_beyond: id
            email
            name
            lastname
            scndlastname
            id18
            country
            professional_ID
            specialism
          }
          event {
            webinarId: id
            webinarCategory: category {
              name
            }
            webinarTitle: title
          }
        }
      }
      `,
      token
    );

    return data?.trackings;
  };

  const isSendedToMixpanel = async ({ eventId, token }) => {
    const data = await queryAPI(
      `
      query {
        isSendedToMixpanel(event_id: ${eventId})
      } 
    `,
      token
    );

    return data?.isSendedToMixpanel;
  };

  const markSendedToMixpanel = async ({ eventId, token }) => {
    const data = await queryAPI(
      `
      mutation {
        markSendedToMixpanel(event_id: ${eventId})
      }
    `,
      token
    );

    return data?.markSendedToMixpanel;
  };

  const SavePlay = async ({ eventSlug, token }) => {
    const data = await queryAPI(
      `
      mutation {
        savePlay(event_slug: "${eventSlug}")
      }
    `,
      token
    );

    return data?.savePlay;
  };

  const SaveDownloadDiploma = async ({ eventSlug, token }) => {
    const data = await queryAPI(
      `
      mutation {
        saveDownloadDiploma(event_slug: "${eventSlug}")
      }
    `,
      token
    );

    return data?.saveDownloadDiploma;
  };

  const CreateButtonTracking = async ({
    eventId,
    redirectionButton,
    token,
  }) => {
    const data = await queryAPI(
      `
      mutation {
        createButtonTracking(event_id: ${eventId}, redirection_button: "${redirectionButton}")
      }
    `,
      token
    );

    return data?.createButtonTracking;
  };

  const IsNewRecord = async (eventId, token) => {
    const data = await queryAPI(
      `
      query {
        isNewRecord(event_id: ${eventId})
      }
    `,
      token
    );

    return data?.isNewRecord;
  };

  const UpdateSurveyAnswered = async (eventId, token) => {
    const data = await queryAPI(
      `mutation {
        updateSurveyAnswered(event_id: ${eventId})
      }`,
      token
    );

    return data?.updateSurveyAnswered;
  };

  return {
    createTrackingLatam,
    createVODSummitTracking,
    userExists,
    updateVODSummitAccumulatedTime,
    EventBySlug,
    GetTypeformReponse,
    getDiplomaProgress,
    getTalkById,
    getFirstEventTalk,
    getEventTalks,
    GetScore,
    SaveScore,
    Countries,
    Specialties,
    LoginLatam,
    Login,
    EventById,
    GetMessages,
    SendMessage,
    CreateTracking,
    Logout,
    Register,
    UpdateTracking,
    GetUserTracking,
    CheckConstancy,
    GetUserEmail,
    EventExists,
    ReadUserById,
    ReadUserByLiveId,
    GetTracking,
    CreateConstancy,
    GetSFToken,
    SendToSFLogin,
    SendToSFRegister,
    RegisterLatam,
    getUserIDByEmail,
    registerFromBeyond,
    getUserInfo,
    getUserInfoById,
    getEventInfoById,
    getEventPageData,
    getUserByEmail,
    hasAttended,
    markAsAttended,
    getEventBySlug,
    getUserProperties,
    updateUserMixpanelRegistered,
    getAllTrackings,
    isSendedToMixpanel,
    markSendedToMixpanel,
    SavePlay,
    SaveDownloadDiploma,
    updateDataMismatch,
    CreateButtonTracking,
    IsNewRecord,
    UpdateSurveyAnswered,
  };
})();
export default api;
